import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Card,
  CardBody,
  CardHeader,
  Divider,
  Flex,
  Heading,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  Spinner,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import {
  capitalizeFirstLetter,
  getBackendURL,
  getDateInFormat,
  apiFetch,
} from '../../../utils/utils';

function DistributorPaymentsPage() {
  const [payments, setPayments] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchPayments = useCallback(() => {
    setIsLoading(true);
    apiFetch(`${getBackendURL()}/admin/distributor/payments?page=${page}&limit=${limit}`)
      .then(response => response.json())
      .then(response => {
        if (response !== null && response.payments && response.payments.length > 0) {
          let payments = [];
          response.payments.forEach(payment => {
            payments.push({
              id: payment._id,
              distributorName: payment.distributorName,
              planName: payment.planName,
              amount: payment.amount,
              txnDate: getDateInFormat(payment.txnDate),
              txnNumber: payment.txnNumber,
            });
          });
          setPayments(payments);
          setTotal(response.total);
        } else {
          setPayments([]);
          setTotal(0);
        }
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setPayments([]);
        setTotal(0);
        setIsLoading(false);
      });
  }, [page, limit]);

  useEffect(() => {
    fetchPayments();
  }, [fetchPayments]);

  return (
    <>
      <Breadcrumb marginTop={2} marginLeft={2}>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/">
            Home
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/distributors/payments">
            Payments
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
      <Stack mt={4} direction={{ base: 'column', lg: 'row' }}>
        <Flex flex={1}>
          <Box w={'100%'}>
            <Card bg={useColorModeValue('white', 'gray.700')}>
              <CardHeader>
                <Heading size="md">Payments</Heading>
              </CardHeader>
              <Divider />
              <CardBody>
                <TableContainer>
                  {isLoading ? (
                    <Flex justify="center" align="center" minH="200px">
                      <Spinner
                        thickness="4px"
                        speed="0.65s"
                        emptyColor="gray.200"
                        color="blue.500"
                        size="xl"
                      />
                    </Flex>
                  ) : (
                    <Table variant="simple">
                      <Thead>
                        <Tr>
                          <Th>Sr. No</Th>
                          <Th>Distributor Name</Th>
                          <Th>Amount</Th>
                          <Th>Transaction Date</Th>
                          <Th>Transaction Number</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {payments.map((payment, index) => {
                          return (
                            <Tr key={`${payment.id} - ${index}`}>
                              <Td>{(page - 1) * limit + index + 1}</Td>
                              <Td>
                                {capitalizeFirstLetter(payment.distributorName)}
                              </Td>
                              <Td>{payment.amount}</Td>
                              <Td>{payment.txnDate} </Td>
                              <Td>{payment.txnNumber}</Td>
                            </Tr>
                          );
                        })}
                      </Tbody>
                    </Table>
                  )}
                </TableContainer>
              </CardBody>
              <Divider />
              <Flex p={4} justify="space-between" align="center">
                <Text fontSize="sm" color="gray.500">
                  Showing {total > 0 ? (page - 1) * limit + 1 : 0} to{' '}
                  {Math.min(page * limit, total)} of {total} results
                </Text>
                <Flex gap={2}>
                  <Button
                    size="sm"
                    onClick={() => setPage(Math.max(1, page - 1))}
                    disabled={page === 1}
                  >
                    Previous
                  </Button>
                  <Button
                    size="sm"
                    onClick={() => setPage(page + 1)}
                    disabled={page * limit >= total}
                  >
                    Next
                  </Button>
                </Flex>
              </Flex>
            </Card>
          </Box>
        </Flex>
      </Stack>
    </>
  );
}

export default DistributorPaymentsPage;
